import { ShowChatBoxContext } from '@/context';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import { useSession } from 'next-auth/react';
import * as React from 'react';

export const useShowChat = () => {
	const { showChatBox, setShowChatBox } = React.useContext(ShowChatBoxContext);

	const { data: session } = useSession();
	const userId = session?.user.user.id;

	const openShowChatBox = () => {
		setShowChatBox(true);
		setLocalStorage(`showChatBox_${userId}`, true);
	};

	const closeShowChatBox = () => {
		setShowChatBox(false);
		setLocalStorage(`showChatBox_${userId}`, false);
	};

	React.useEffect(() => {
		if (!userId) return;

		const key = `showChatBox_${userId}`;
		const saved = getLocalStorage(key);
		if (saved === null || saved === undefined) {
			setLocalStorage(key, false);
			setShowChatBox(false);
		}
	}, [userId]);

	return {
		showChatBox,
		setShowChatBox,
		openShowChatBox,
		closeShowChatBox,
	};
};
